import PageForMarketing from 'components/PageForMarketing'
import PageWithTailwind from 'components/PageWithTailwind'
import LandingView from 'views/LandingView'

const index = () =>
  <PageForMarketing>
    <PageWithTailwind
      title='Reinventing blog commenting'
      description='Blotter fixes the problems with traditional blog comment services. No more empty blog comments. Less spam. More authentic discussion.'
    >
      <LandingView />
    </PageWithTailwind>
  </PageForMarketing>

export const getStaticProps = () => {
  return {
    props: {},
  }
}

export default index
